export default "__VITE_ASSET__5f86a401__"